// extracted by mini-css-extract-plugin
module.exports = {"dialog":"crm-c_dialog__1-YqQ","container":"crm-c_container__1UBtR","actionButton":"crm-c_actionButton__3vUsa","form":"crm-c_form__1CRFe","reply":"crm-c_reply__3J9Gy"};